import React from 'react';
import PropTypes from 'prop-types';
import { AtomicText } from './Text';

const defaultStyles = {
  mobile: {
    color: 'black',
    font: `700 16px/17px 'CentraNo2', sans-serif`,
    'letter-spacing': '0.28px'
  },
  tablet: {},
  desktop: {}
};

const xlStyles = {
  mobile: {
    color: 'black',
    'font-size': '31px',
    'letter-spacing': '0.75px',
    'line-height': '26px',
    'font-family': `'GrifitoM', sans-serif`
  },
  tablet: {},
  desktop: {
    'font-size': '39px',
    'letter-spacing': '0.75px',
    'line-height': '33px'
  }
};

const Title = ({ text, className, element = 'h4', xl }) => (
  <AtomicText
    element={element}
    mobileDesign={xl ? xlStyles.mobile : defaultStyles.mobile}
    tabletDesign={xl ? xlStyles.tablet : defaultStyles.tablet}
    desktopDesign={xl ? xlStyles.desktop : defaultStyles.desktop}
    className={className || 'title'}
  >
    {text}
  </AtomicText>
);

Title.defaultProps = {
  element: 'h4',
  className: undefined,
  xl: undefined
};

Title.propTypes = {
  text: PropTypes.string.isRequired,
  element: PropTypes.string,
  className: PropTypes.string,
  xl: PropTypes.bool
};

export default Title;
